import script from "./SmartChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartChatbot.vue?vue&type=script&setup=true&lang=js"

import "./SmartChatbot.vue?vue&type=style&index=0&id=611d7bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611d7bd8"]])

export default __exports__